import angular from 'angular';

import directive from './lazyLoader.directive';
import service from './lazyLoader.service';

import Browser from 'cars-ng-browser';
import ActiveTest from '../carsNgActiveTest';

export default angular.module('cars.vdp.shared.lazyLoader', [
    /* your module dependencies go here */
    Browser,
    ActiveTest
])

.directive('cuiLazyLoader', directive)
.factory('lazyLoader', service)

.name;
